<template>
  <main>
    <hero :heading="entry.title" :subheading="entry.hero.subheading" :images="entry.heroImages" position="bottom" />
    <div class="c-section">
      <div class="o-wrapper">
        <div class="c-section__header">
          <h2 class="c-section__heading">Track your bird</h2>
        </div>
        <div class="o-box-off u-ff-alt u-mb u-mb+@tablet u-pb" v-html="entry.body"></div>
        <div class="c-toolbar">
          <div class="c-toolbar__items">
            <div class="c-toolbar__item" v-if="filterDates.length > 0">
              <div class="c-toolbar__heading u-st1">Year</div>
              <div class="c-toolbar-select">
                <select class="c-toolbar-select__select" v-model="filterDate" @change="resizeSelect" style="width:45px">
                  <option selected>All</option>
                  <option v-for="option in filterDates" :key="option.id">{{ option }}</option>
                </select>
              </div>
            </div>
            <div class="c-toolbar__item" v-if="filterBands.length > 0">
              <div class="c-toolbar__heading u-st1">Band Number</div>
              <div class="c-toolbar-select">
                <select class="c-toolbar-select__select" v-model="filterBand" @change="resizeSelect" style="width:45px">
                  <option selected>All</option>
                  <option v-for="option in filterBands" :key="option.id">{{ option }}</option>
                </select>
              </div>
            </div>
            <div class="c-toolbar__item" v-if="filterNames.length > 0">
              <div class="c-toolbar__heading u-st1">Birds Name</div>
              <div class="c-toolbar-select">
                <select class="c-toolbar-select__select" v-model="filterName" @change="resizeSelect" style="width:45px">
                  <option selected>All</option>
                  <option v-for="option in filterNames" :key="option.id">{{ option }}</option>
                </select>
              </div>
            </div>
            <div class="c-toolbar__item c-toolbar__item--right">
              <input class="c-toolbar-input" type="text" placeholder="Search" v-model="filterQuery">
            </div>
          </div>
        </div>
        <table v-if="tableDataFiltered.length > 0">
          <tbody class="c-table list">
            <tr class="c-table__row">
              <td class="c-table__cell c-table__cell--heading">Year</td>
              <td class="c-table__cell c-table__cell--heading">Band Number</td>
              <td class="c-table__cell c-table__cell--heading">Birds Name</td>
              <td class="c-table__cell c-table__cell--heading">Fledge Date</td>
              <td class="c-table__cell c-table__cell--heading">Latest Update</td>
            </tr>
          </tbody>
          <tbody class="c-table list">
            <tr class="c-table__row" v-for="row in tableDataFiltered" :key="row.id">
              <td class="c-table__cell" :class="{ 'c-table__cell--large' : index === (row.length - 1) }" v-for="(cell, index) in row" :key="cell.id">{{ cell }}</td>
            </tr>
          </tbody>
        </table>
        <p class="u-mb0" v-else>Sorry, we can't find any birds.</p>
      </div>
    </div>
    <banner />
  </main>
</template>

<script>
import axios from 'axios'
import Hero from '@/components/Hero.vue'
import Banner from '@/components/Banner.vue'
import Papa from 'papaparse'
import _ from 'lodash'

export default {
  name: 'Birds',
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: {
    Hero: Hero,
    Banner: Banner
  },
  data () {
    return {
      title: '',
      entry: null,
      tableData: null,
      tableDataFiltered: null,
      filterDate: 'All',
      filterBand: 'All',
      filterName: 'All',
      filterQuery: '',
      filterDates: [],
      filterBands: [],
      filterNames: []
    }
  },
  mounted () {
    this.getEntry()
  },
  watch: {
    filterDate: function () {
      this.getFilteredValues()
    },
    filterBand: function () {
      this.getFilteredValues()
    },
    filterName: function () {
      this.getFilteredValues()
    },
    filterQuery: function () {
      this.getFilteredValues()
    }
  },
  methods: {
    resizeSelect (event) {
      let elem = event.target
      let selectedText = elem.options[elem.selectedIndex].text
      elem.style.width = 20 + (selectedText.length * 8) + 'px'
    },
    getEntry () {
      axios
        .get('api/birds.json')
        .then(response => {
          this.entry = response.data
          this.title = this.entry.title
          this.parseCsv()
        })
    },
    parseCsv () {
      const vm = this
      Papa.parse(vm.entry.file, {
        download: true,
        complete: function (results) {
          vm.tableData = results.data
          vm.tableDataFiltered = vm.tableData
          vm.getUniqueFilterValues()
        }
      })
    },
    getUniqueFilterValues () {
      this.filterDates = _.map(this.tableData, function (item) { return item[0] })
      this.filterDates = _.uniq(this.filterDates)
      this.filterBands = _.map(this.tableData, function (item) { return item[1] })
      this.filterBands = _.uniq(this.filterBands)
      this.filterNames = _.map(this.tableData, function (item) { return item[2] })
      this.filterNames = _.uniq(this.filterNames)
    },
    getFilteredValues () {
      const vm = this
      this.tableDataFiltered = _.filter(this.tableData, (item) => {
        const filteredDates = (this.filterDate !== 'All' ? _.includes(item, vm.filterDate) : [])
        const filteredBands = (this.filterBand !== 'All' ? _.includes(item, vm.filterBand) : [])
        const filteredNames = (this.filterName !== 'All' ? _.includes(item, vm.filterName) : [])
        const filteredQuery = (this.filterQuery !== '' ? _.includes(item, vm.filterQuery) : [])

        return (filteredDates && filteredBands && filteredNames && filteredQuery)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Birds.vue